"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  0: 'Pending',
  1: 'Active',
  2: 'Account Disabled',
  3: 'Parental Leave',
  4: 'Leave of Absence',
  5: 'Temporary Lay Off',
  6: 'Disability',
  7: 'Strike',
  8: 'Late Applicant',
  9: 'Terminated',
  10: 'Approved Leave',
  11: 'Survivor Benefits',
  12: 'Severance',
  'Pending': 0,
  'Active': 1,
  'Account Disabled': 2,
  'Parental Leave': 3,
  'Leave of Absence': 4,
  'Temporary Lay Off': 5,
  'Disability': 6,
  'Strike': 7,
  'Late Applicant': 8,
  'Terminated': 9,
  'Approved Leave': 10,
  'Survivor Benefits': 11,
  'Severance': 12
};